module.exports = __webpack_public_path__ + "img/15pts12.3f822a48.png";